import {
  UPLOAD_REQUEST,
  UPLOAD_SUCCESS,
  UPLOAD_FAIL,
} from "../constants/AuthConstant";

const initialState = {
  loading: false,
  result: [],
  msg: "",
  error: "",
};

const ResumeUploadReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPLOAD_REQUEST:
      return {
        ...state,
        loading: action.payload,
      };
    case UPLOAD_SUCCESS:
      return {
        ...state,
        result: action.result.data,
        loading: action.payload,
        msg: action.msg,
      };
    case UPLOAD_FAIL:
      return {
        ...state,
        error: action.error,
        loading: action.payload,
        msg: action.msg,
      };
    default:
      return state;
  }
};

export default ResumeUploadReducer;
